import script from "./TeamOrder.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeamOrder.vue?vue&type=script&setup=true&lang=ts"

import "./TeamOrder.vue?vue&type=style&index=0&id=58884dc4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58884dc4"]])

export default __exports__